import { IRequestWithPageSortFilterSearch, TPageResponse } from 'redux/types';
import { TUser } from '../user/types';

export type TEudrStore = {
	regParser: TEudrRegParseResponsePayload;
	regParserLoading: boolean;
	regParserError: string;
	registerLoading: boolean;
	registerError: string;
	plans: TEudrPlansResponsePayload;
	serviceStatuses: TEudrServiceStatusesResponsePayload;
	eudrItems: TEudrItemsResponsePayload;
	eudrItemsLoading: boolean;
	generateInvoiceEudrLoading: boolean;
	downloadEudrLastInvoiceLoading: boolean;
	activateEudrLoading: boolean;
	activateEudrError: string;
};

export type TEudrPlan = {
	id: number;
	name: string;
	amount: number;
	monthsIncluded: number;
	invoiceName: string;
};

export type TEudrPlans = TEudrPlan[];
export type TEudrPlansResponsePayload = TEudrPlans | null;

export type TEudrServiceStatus = {
	id: number;
	name: string;
	description: string;
};

export type TEudrServiceStatuses = TEudrServiceStatus[];
export type TEudrServiceStatusesResponsePayload = TEudrServiceStatuses | null;

export type TEudrRegParseRequest = {
	urlEncodedRawRegistrationData: string;
};

export type TEudrRegParsed = {
	sellingTypeOfProducts?: string;
	isSellingToEU?: boolean;
	sellingPlace?: string;
	firstName?: string;
	lastName?: string;
	phoneNumber?: string;
	email?: string;
	company?: string;
	address1?: string;
	address2?: string;
	cityTown?: string;
	stateRegionProvince?: string;
	zipCode?: string;
	country?: string;
	businessRegistrationNumber?: string;
	storeAddress?: string;
	actualAmount?: number;
	subscriptionPlanId?: number;
	eori?: string;
	periodStart?: string;
	periodEnd?: string;
};

export type TEudrRegParseResponsePayload = TEudrRegParsed | null;

export type TEudrRegisterRequest = {
	sellingTypeOfProducts: string;
	isSellingToEU: boolean;
	sellingPlace: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
	company: string;
	address1: string;
	address2: string;
	cityTown: string;
	stateRegionProvince: string;
	zipCode: string;
	country: string;
	storeAddress: string;
	subscriptionPlanId: number;
	periodStart: string;
	periodEnd: string;
	businessRegistrationNumber: string;
	eori: string;
	actualAmount: number;
};

// ============== LIST ==============
// [
//   {
//     "id": 5,
//     "name": "Cancelled",
//     "description": "Set manually by operator or user"
//   },
//   {
//     "id": 4,
//     "name": "Disabled",
//     "description": "Set manually by operator when needed"
//   },
//   {
//     "id": 2,
//     "name": "Invoiced",
//     "description": "Set when invoice is issued and sent to the customer."
//   },
//   {
//     "id": 1,
//     "name": "New",
//     "description": "Default status when EM registered for EUDR service"
//   },
//   {
//     "id": 3,
//     "name": "Registered",
//     "description": "Set when EM is registered in the TRACES NT"
//   }
// ]

export enum EServiceStatus {
	NEW = 'New',
	INVOICED = 'Invoiced',
	REGISTERED = 'Registered',
	CANCELLED = 'Cancelled',
	DISABLED = 'Disabled',
}

export enum EServiceStatusID {
	NEW = 1,
	INVOICED = 2,
	REGISTERED = 3,
	DISABLED = 4,
	CANCELLED = 5,
}

export type TEudrItemsRequest = IRequestWithPageSortFilterSearch;

export type TEudrItem = {
	id: number;
	emId: number;
	fullName: string;
	nominatedEmail: string | null;
	nominatedPerson: string | null;
	tinNumber: string | null;
	phone: string | null;
	periodStart: string | null;
	periodEnd: string | null;
	createdAt: string | null;
	author: TUser | null;
	subscriptionPlanId: number | null;
	subscriptionPlanName: string | null;
	invoiceId: number | null;
	paymentStatus: string | null;
	invoiceNumber: number | null;
	amount: number | null;
	actualAmount: number | null;
	invoiceStatus: string | null;
	serviceStatusId: EServiceStatusID | null;
	serviceStatusName: EServiceStatus | null;
	updatedAt: string | null;
	updatedBy: TUser | null;
	cancelledAt: string | null;
	cancelledBy: TUser | null;
	eori: string | null;
};

export type TEudrItems = TEudrItem[];
export type TEudrItemsResponse = TPageResponse<TEudrItem>;
export type TEudrItemsResponsePayload = TEudrItemsResponse | null;

// ============== INVOICE GENERATION ==============
export type TGenerateEudrInvoiceRequest = {
	id: number;
};

// ============== INVOICE PDF DOWNLOAD ==============
export type TDownloadEudrLastInvoiceRequest = {
	id: number;
};
export type TDownloadEudrLastInvoiceResponse = Blob;
export type TDownloadEudrLastInvoiceResponsePayload = TDownloadEudrLastInvoiceResponse | null;

export type TEudrActivateRequest = {
	id: number;
};
